export namespace $auth {
    export async function getOTP(ac?: AbortController) {
        if(!('OTPCredential' in window)) throw 'OTP not supported';

        const otp = await navigator.credentials.get({ otp: { transport: ['sms'] }, signal: ac?.signal } as any) as any;
        if(!otp?.code) throw 'No OTP received';
        return otp.code as string;
    }
}
